import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import styles from '../../Style/LayerOverview.module.scss';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

interface ToggleItemProps {
  label: string;
  icon?: ReactNode;
  iconStyle?: string;
  disabled?: boolean;
  isActive: boolean;
  onToggle: () => void;
  labelStyle?: React.CSSProperties;
}

const ToggleItem: React.FC<ToggleItemProps> = ({
  label,
  icon,
  iconStyle,
  disabled = false,
  isActive,
  onToggle,
  labelStyle,
}) => {
  return (
    <div className={`${styles.menuRow}`}>
      <div className={styles.iconLabel}>
        {icon && React.isValidElement(icon) ? (
          icon
        ) : iconStyle ? (
          <div className={iconStyle} />
        ) : null}
        <Typography
          style={{
            marginLeft: 5,
            color: disabled ? 'grey' : 'black',
            ...labelStyle,
          }}
        >
          {label}
        </Typography>
      </div>
      <div className={styles.groupItem}>
        <div
          onClick={() => !disabled && onToggle()}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: '20px',
          }}
        >
          {disabled ? (
            <EyeInvisibleOutlined disabled style={{ cursor: 'not-allowed' }} />
          ) : isActive ? (
            <EyeOutlined />
          ) : (
            <EyeInvisibleOutlined />
          )}
        </div>
      </div>
    </div>
  );
};

export default ToggleItem;
